// Brand assets + constants
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_venpa-design-refresh/artifacts/t6bw6lp7_logovenpa.png";
export const BRAND_GRADIENT = ["#FF8A6B", "#C57DFF", "#4F7DF2", "#7AB8FF"];
// Single source of truth for the founder's photo — used by both the visible
// Testimonials section and the Person JSON-LD (JsonLd.jsx), so they can't drift.
export const FOUNDER_PHOTO_URL = "https://customer-assets.emergentagent.com/job_venpa-design-refresh/artifacts/dd2o29ju_A.png";
